import { type AuthenticateUserMutation } from '#app/__generated__/relay/AuthenticateUserMutation.graphql.js';
import { type DeauthenticateUserMutation } from '#app/__generated__/relay/DeauthenticateUserMutation.graphql.js';
import { type Disposable, type UseMutationConfig } from '@contra/relay';
import { createContext } from 'react';

const invariant = () => {
  throw new Error('Attempted to call useAuth outside of AuthContext.Provider.');
};

export const AuthContext = createContext<{
  isLoggingIn: boolean;
  isLoggingOut: boolean;
  login: (config: UseMutationConfig<AuthenticateUserMutation>) => Disposable;
  logout: (config: UseMutationConfig<DeauthenticateUserMutation>) => void;
}>({
  isLoggingIn: false,
  isLoggingOut: false,
  login: invariant,
  logout: invariant,
});
